import {ABORT_UPLOAD} from '../middleware/fileUploader';

export const FILE_ADDED = 'FILE_ADDED';
export const UPLOAD_INITIALIZED = 'UPLOAD_INITIALIZED';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD';

export const uploadInitialized = (tempId, id) => ({
  type: UPLOAD_INITIALIZED,
  tempId,
  id,
});

export const uploadProgress = (tempId, progress) => ({
  type: UPLOAD_PROGRESS,
  tempId,
  progress,
});

export const uploadSuccess = (tempId, metadata) => ({
  type: UPLOAD_SUCCESS,
  tempId,
  metadata,
});

export const uploadError = (tempId, error) => ({
  type: UPLOAD_ERROR,
  tempId,
  error,
});

export const removeUpload = tempId => ({
  type: REMOVE_UPLOAD,
  tempId,
  [ABORT_UPLOAD]: true,
});

export const uploadFile = (tempId, file) => ({
  type: FILE_ADDED,
  tempId,
  file,
});



// WEBPACK FOOTER //
// ./src/actions/file.js